import {
    slugAiAgentSandboxEscapes,
    slugAiThreats,
    slugAncpiRansomware,
    slugChat3Creators,
    slugCloudFiles,
    slugCommunitySafe,
    slugDeepCdr,
    slugFakeClaudeDesktop,
    slugFileScans100k,
    slugFileTransit,
    slugGrafanaGhost,
    slugJadePuffer,
    slugMastraNpm,
    slugMultiEngine,
    slugSaferInternet,
    slugSearchLeak,
    slugSecureChromeEdgeDownloads,
    slugSecurePipelineStudio,
    slugStaticVsDynamicAnalysis,
    slugStorageCloud,
    slugUrlScanners,
    slugVtAlternative,
} from './meta';
import type { BlogPostLoader } from './types';

export * from './meta';

export const BLOG_LOADERS: Record<string, BlogPostLoader> = {
    [slugCloudFiles]: (t) => import('./posts/cloud-files').then((m) => m.load(t)),
    [slugCommunitySafe]: (t) => import('./posts/community-safe').then((m) => m.load(t)),
    [slugSaferInternet]: (t) => import('./posts/safer-internet').then((m) => m.load(t)),
    [slugMultiEngine]: (t) => import('./posts/multi-engine').then((m) => m.load(t)),
    [slugUrlScanners]: (t) => import('./posts/url-scanners').then((m) => m.load(t)),
    [slugFileScans100k]: (t) => import('./posts/100k-file-scans').then((m) => m.load(t)),
    [slugFileTransit]: (t) => import('./posts/file-security-transit').then((m) => m.load(t)),
    [slugStorageCloud]: (t) => import('./posts/storage-security-cloud').then((m) => m.load(t)),
    [slugAiThreats]: (t) => import('./posts/ai-threats').then((m) => m.load(t)),
    [slugSecureChromeEdgeDownloads]: (t) => import('./posts/secure-downloads').then((m) => m.load(t)),
    [slugChat3Creators]: (t) => import('./posts/chat3-creators').then((m) => m.load(t)),
    [slugGrafanaGhost]: (t) => import('./posts/grafana-ghost').then((m) => m.load(t)),
    [slugVtAlternative]: (t) => import('./posts/vt-alternative').then((m) => m.load(t)),
    [slugSecurePipelineStudio]: (t) => import('./posts/secure-pipeline-studio').then((m) => m.load(t)),
    [slugStaticVsDynamicAnalysis]: (t) => import('./posts/static-vs-dynamic-analysis').then((m) => m.load(t)),
    [slugDeepCdr]: (t) => import('./posts/deep-cdr').then((m) => m.load(t)),
    [slugMastraNpm]: (t) => import('./posts/mastra-npm-attack').then((m) => m.load(t)),
    [slugSearchLeak]: (t) => import('./posts/searchleak-copilot').then((m) => m.load(t)),
    [slugJadePuffer]: (t) => import('./posts/jadepuffer-langflow').then((m) => m.load(t)),
    [slugAiAgentSandboxEscapes]: (t) => import('./posts/ai-agent-sandbox-escapes').then((m) => m.load(t)),
    [slugAncpiRansomware]: (t) => import('./posts/ancpi-ransomware').then((m) => m.load(t)),
    [slugFakeClaudeDesktop]: (t) => import('./posts/fake-claude-desktop').then((m) => m.load(t)),
};
